import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router/index';
import axios from 'axios';
import FileRegister from '@/components/FileRegister.vue';

Vue.use(Vuex);

let userData = '{}';
try {
  userData = JSON.parse(localStorage.getItem('userData') || '{}');
} catch (error) {
  console.error('Error parsing userData from localStorage:', error);
  userData = {}; // Fallback to an empty object in case of an error
}

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    userType: localStorage.getItem('userType'),
    idToken:localStorage.getItem('idToken'),
    uid: localStorage.getItem('uid'),
    // userData: JSON.parse(localStorage.getItem('userData') || '{}'),
    userData: userData,
    name:localStorage.getItem('name'),
    email:localStorage.getItem('email'),

    //Subscription
    noRestriction: localStorage.getItem('noRestriction') === 'true',
    listAndView: localStorage.getItem('listAndView') === 'true',
    fileUploadLimit: localStorage.getItem('fileUploadLimit') === 'true',
    uploadLimit:localStorage.getItem('uploadLimit'),
    fileRegister:localStorage.getItem('fileRegister') === 'true',
    fileExport:localStorage.getItem('fileExport') === 'true',
    planEndsIn:localStorage.getItem('planEndsIn'),
    isFree:localStorage.getItem('isFree') === 'true',
    isBulkSubscription:localStorage.getItem('isBulkSubscription') === 'true',


    //Bulk Save
    noOfAccounts: localStorage.getItem('noOfAccounts'),
    orgName: localStorage.getItem('orgName'),
    orgRepresentativeRole: localStorage.getItem('orgRepresentativeRole'),
    orgAddress: localStorage.getItem('orgAddress'),
    invoiceAddress: localStorage.getItem('invoiceAddress'),
    // sameAsAbove: localStorage.getItem('sameAsAbove') === 'true',
    gstNumber: localStorage.getItem('gstNumber'),
    officialEmail: localStorage.getItem('officialEmail'),
    orgRepresentativeName: localStorage.getItem('orgRepresentativeName'),
    voucherCode: localStorage.getItem('voucherCode'),
    currencySymbol: localStorage.getItem('currencySymbol'),


    data: {},
    utype: null,
    menus: [],
    initial: '',
    appLoading: false,
  },
  mutations: {
    setUtype(state, utype) {
      state.utype = utype;
    },
    setData(state, payload) {
      state.data = payload;
    },
    setUserData(state, payload) {
      state.userData = payload;
    },
    setUid(state, payload) {
      state.uid = payload;
    },
    appLoading(state) {
      state.isLoading = true;
    },
    setNoOfAccounts(state, value) {
      state.noOfAccounts = value;
    },
    setOrgName(state, value) {
      state.orgName = value;
    },
    setOrgRepresentativeRole(state, value) {
      state.orgRepresentativeRole = value;
    },
    setOrgAddress(state, value) {
      state.orgAddress = value;
    },
    setInvoiceAddress(state, value) {
      state.invoiceAddress = value;
    },
    // setSameAsAbove(state, value) {
    //   state.sameAsAbove = value;
    // },
    setGstNumber(state, value) {
      state.gstNumber = value;
    },
    setOfficialEmail(state, value) {
      state.officialEmail = value;
    },
    setOrgRepresentativeName(state, value) {
      state.orgRepresentativeName = value;
    },
    setVoucherCode(state, value) {
      state.voucherCode = value;
    },
    setCurrencySymbol(state, value) {
      state.currencySymbol = value;
    },
    sessionOut(state) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      localStorage.removeItem('uid');

      localStorage.removeItem('noRestriction');
      localStorage.removeItem('listAndView');
      localStorage.removeItem('fileUploadLimit');
      localStorage.removeItem('uploadLimit');
      localStorage.removeItem('uploadLimit');

      localStorage.removeItem('fileRegister');
      localStorage.removeItem('fileExport');
      localStorage.removeItem('planEndsIn');
      localStorage.removeItem('isFree');
      localStorage.removeItem('isBulkSubscription');


      localStorage.removeItem('noOfAccounts');
      localStorage.removeItem('orgName');
      localStorage.removeItem('orgRepresentativeRole');
      localStorage.removeItem('orgAddress');
      localStorage.removeItem('invoiceAddress');
      // localStorage.removeItem('sameAsAbove');
      localStorage.removeItem('gstNumber');
      localStorage.removeItem('officialEmail');
      localStorage.removeItem('orgRepresentativeName');
      localStorage.removeItem('voucherCode');

      state.isLoggedIn = false;
      state.userData = {};
      state.uid = null;
      router.push('/login');
    },
    logoutUser(state) {
      axios({
        method: 'POST',
        url: '/user/logout',
        headers: {
          token: localStorage.getItem('token'),
        },
      }).then((response) => {
        if (response.data) {
          state.isLoggedIn = false;
          state.userData = {};
          state.initial = '';
          localStorage.removeItem('token');
          localStorage.removeItem('userData');
          localStorage.removeItem('uid');

         

      localStorage.removeItem('noRestriction');
      localStorage.removeItem('listAndView');
      localStorage.removeItem('fileUploadLimit');
      localStorage.removeItem('uploadLimit');
      localStorage.removeItem('uploadLimit');

      localStorage.removeItem('fileRegister');
      localStorage.removeItem('fileExport');
      localStorage.removeItem('planEndsIn');
      localStorage.removeItem('isFree');


      localStorage.removeItem('noOfAccounts');
      localStorage.removeItem('orgName');
      localStorage.removeItem('orgRepresentativeRole');
      localStorage.removeItem('orgAddress');
      localStorage.removeItem('invoiceAddress');
      // localStorage.removeItem('sameAsAbove');
      localStorage.removeItem('gstNumber');
      localStorage.removeItem('officialEmail');
      localStorage.removeItem('orgRepresentativeName');
      localStorage.removeItem('voucherCode');

          router.push('/login');
        }
      });
    },
    setRole(state, item) {
      state.role = item;
    },
    loginUser(state, payload) {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('userData', JSON.stringify(payload.userData));
      localStorage.setItem('uid', payload.uid);
      state.isLoggedIn = true;
      state.userData = payload.userData;
      state.uid = payload.uid;
    },
  },
  getters: {
    currentUser: (state) => state.userData,
  },
});
